export const dateFormats = {
  ddMMyyyy: 'dd/MM/yyyy',
  ddMMyyyyhhmma: 'dd/MM/yyyy, hh:mm a',
};
